import { ICssShadow } from './../ICssShadow.interface';
import { ICustomPropConfig } from './../../prop-editors.moudule/custom-prop-config.interface';
import { Observer } from 'rxjs/Observer';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SeScrollingTextConfig } from './se-scrolling-text-config.class';
import { IScreenElement } from './../screen-element.interface';
import { ScreenElementClass } from './../screen-element.class';
import { Subject } from 'rxjs/Subject';
import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChange,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { DesignerGlobalService } from './../../designer-global.service';
import { Ease, TimelineMax, Power4, Power1, Power2, Power3, Bounce, Elastic, TweenMax, Linear, TweenConfig } from 'gsap';
import Draggable from 'gsap/Draggable';
import * as _ from 'lodash';

@Component({
  selector: 'app-se-scrollingtext',
  templateUrl: './se-scrollingtext.component.html',
  styleUrls: ['./se-scrollingtext.component.css']
})
export class SeScrollingtextComponent extends ScreenElementClass implements IScreenElement, OnInit, OnDestroy, AfterViewInit, AfterContentInit, OnChanges {

  public elementConfig: SeScrollingTextConfig = new SeScrollingTextConfig(); // settings for this element

  public scrollTween: TweenMax;
  public adornerSizeSub: Subscription;
  public sizeChangeObserver: Observer<any> = {
    next: (x) => {
      this.updateTween();
    },
    error: (err) => {

    },
    complete: () => {

    }
  };

  @ViewChild('scrollBox') scrollBox;
  @ViewChild('scrollContainer') scrollContainer;
  @ViewChild('textboxWrapper') textboxWrapper;

  // element specifc prop bindings
  @HostBinding('style.background-color') get getBackgroundColor() { return this.elementConfig.backgroundColor; }

  // text shadows
  @HostBinding('style.text-shadow') get geTextShadows() {
    // build box shadow string with all the shadows
    let shadowStr = '';
    if (this.elementConfig.textShadows.length > 0) {
      this.elementConfig.textShadows.forEach((shadow: ICssShadow) => {
        shadowStr += `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}, `;
      });
      shadowStr = shadowStr.substring(0, shadowStr.length - 2); // remove last commma
    }
    return this.sanitizer.bypassSecurityTrustStyle(shadowStr);
  }

  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public changeDetectorRef: ChangeDetectorRef,
    public renderer: Renderer2
  ) {
    super(sanitizer); // initilize base class
    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected

    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }
  }

  ngOnInit() {

    this.startScroll();


  }


  changeHook(change: SimpleChange) {
    this.updateTween();
  }

  ngOnChanges(changes) {
    if (changes.elementConfig) {

    }
  }

  ngOnDestroy() {
    if (this.adornerSizeSub) {
      this.adornerSizeSub.unsubscribe();
    }

  }

  startScroll() {
    this.updateTween();
  }

  stopScroll() {
    if (this.scrollTween) {
      this.scrollTween.kill();
    }
  }

  updateTween() {
    if (!this.textboxWrapper || !this.scrollBox) {
      return;
    }

    const containerWidth = this.elementConfig.width;
    const containerHeight = this.elementConfig.height;

    this.elementConfig.fontSize = containerHeight * .75;
    this.changeDetectorRef.detectChanges(); // apply the change above

    const textWidth = this.scrollBox.nativeElement.clientWidth;
    const textHeight = this.scrollBox.nativeElement.clientHeight;
    if (this.scrollTween) {
      this.scrollTween.kill();
    }

    const baseDuration = (textWidth / 1920) * 8;


    TweenMax.set(this.textboxWrapper.nativeElement, { height: textHeight });

    this.scrollTween = TweenMax.fromTo(this.scrollBox.nativeElement, baseDuration * this.elementConfig.scrollSpeed, {
      x: containerWidth + 50
    }, {
        x: -(textWidth + containerWidth + 50),
        repeat: -1,
        repeatDelay: .3,
        ease: Linear.easeNone
      });

  }


  ngAfterContentInit() {
    this.updateTween();
  }

  ngAfterViewInit() {

  }

  getCustomProperties() {

    const userAdjustableProps: ICustomPropConfig[] = new Array;

    const text: ICustomPropConfig = {
      type: 'pe-input-string',
      name: 'Text',
      propPath: 'elementConfig.text',
      defaultValue: 'Enter the text you would like to display in here',
      tooltip: 'The text of the object',
      showDefaultReset: false,
      groupName: null,
      settings: {
      }
    };


    const font: ICustomPropConfig = {
      type: 'pe-fontpicker',
      name: 'Font',
      propPath: 'elementConfig.fontFamily',
      defaultValue: 'Helvetica',
      tooltip: 'Text font',
      showDefaultReset: false,
      groupName: null,
      settings: {
      }
    };

    const fontColor: ICustomPropConfig = {
      type: 'pe-colorpicker',
      name: 'Font Color',
      propPath: 'elementConfig.fontColor',
      defaultValue: null,
      tooltip: 'The color of the font',
      showDefaultReset: true,
      groupName: null,
      settings: {
      }
    };

    const backgroundColor: ICustomPropConfig = {
      type: 'pe-colorpicker',
      name: 'Background Color',
      propPath: 'elementConfig.backgroundColor',
      defaultValue: null,
      tooltip: 'The color behind the object',
      showDefaultReset: true,
      groupName: null,
      settings: {
      }
    };

    const scrollSpeed: ICustomPropConfig = {
      type: 'pe-slider',
      name: 'Scroll Speed',
      propPath: 'elementConfig.scrollSpeed',
      defaultValue: 1,
      tooltip: 'Speed of the scrolling text',
      showDefaultReset: true,
      groupName: null,
      settings: {
        step: .01,
        direction: 'rtl',
        connect: [true, true],
        start: [1],
        range: {
          min: .3,
          max: 4
        },
        // step: .01,
        tooltips: false,
        orientation: 'horizontal',
      }
    };

    const textShadows: ICustomPropConfig = {
      type: 'pe-shadoweditor',
      name: 'Text Shadow',
      propPath: 'elementConfig.textShadows',
      defaultValue: new Array<ICssShadow>(),
      tooltip: 'this is a sample tooltip',
      showDefaultReset: true,
      groupName: 'effects',
      settings: {
        hasSpread: false,
        buttonText: 'Add Text Shadow',
        horizontal: {
          type: 'pe-slider',
          name: 'Position X',
          propPath: 'x',
          defaultValue: 10,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [10],
            step: 1,
            range: {
              min: -200,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, vertical: {
          type: 'pe-slider',
          name: 'Position Y',
          propPath: 'y',
          defaultValue: 10,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [10],
            step: 1,
            range: {
              min: -200,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, blur: {
          type: 'pe-slider',
          name: 'Blur',
          propPath: 'blur',
          defaultValue: 25,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [25],
            step: 1,
            range: {
              min: 0,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, spread: {
          type: 'pe-slider',
          name: 'Spread',
          propPath: 'spread',
          defaultValue: 1,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [1],
            step: 1,
            range: {
              min: -50,
              max: 100
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        },
        colorConfig: {
          type: 'pe-colorpicker',
          name: 'Color',
          propPath: 'color',
          defaultValue: 'rgba(150,150,150,1)',
          tooltip: 'Sets the color of the shadow',
          showDefaultReset: true,
          groupName: null,
          settings: {
          }


        }

      }
    };

    userAdjustableProps.push(text);
    userAdjustableProps.push(font);
    userAdjustableProps.push(fontColor);
    userAdjustableProps.push(backgroundColor);
    userAdjustableProps.push(scrollSpeed);
    userAdjustableProps.push(textShadows);

    return userAdjustableProps;
  }




}




// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-scrollingtext/se-scrollingtext.component.ts